import { render, staticRenderFns } from "./CompanyFeatureCard.vue?vue&type=template&id=7000f6ef&scoped=true"
import script from "./CompanyFeatureCard.vue?vue&type=script&lang=js"
export * from "./CompanyFeatureCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyFeatureCard.vue?vue&type=style&index=0&id=7000f6ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000f6ef",
  null
  
)

export default component.exports